import { Renderer } from "components/Renderer";
import $ from "jquery";
import { LoginComponentDefinition } from "./login";

export class ModalLogin {
    private static modal;
    public static open(definition) {

        this.modal = $("<div id='c-login__overlay' style='width: 100%; height: 100%; position: absolute; top: 0; left: 0; background-color: rgba(255,255,255,0.8); z-index:310;'></div>").appendTo("body");

        let callback = () => {
            definition.callback();
            this.modal.remove();
        };
        let loginDefinition: LoginComponentDefinition = {
            componentType: "login",
            id: "modal-login",
            mode: "overlay",
            url: definition.url,
            callback,
        };

        Renderer.instance().fullComponentRender(
            loginDefinition,
            this.modal[0],
        );
    }
}
